module.exports = __webpack_public_path__ + "img/picto-EV 3.95fce33d.svg";